//Types
import {IconType} from './inconTypes'

//Component
const ArrowDropUp = ({width, height, fill}: IconType):JSX.Element => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 24 24" width={width} fill={fill}>
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M7 14l5-5 5 5z"/>
        </svg>
    )
}

//Export
export default ArrowDropUp
